
























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import TheFormStaff from '@/components/staff/TheFormStaff.vue';
// Importing functions
import {validateCreateUser} from '@/ts/users/validate-user';
import {postStaff} from '@/ts/staff/post-staff';

export default {
    name: 'PageUsersUpdate',
    components: {
        LayoutApp,
        BaseCard,
        TheFormStaff,
    },
    props: {},
    data() {
        return {
            userData: {},
            errors: [],
            items: [],
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateCreateUser(this.errors, this.userData);

            if (this.errors.length === 0) {
                postStaff(this.errors, this.userData, this.$route.params.id).then(() => {
                    this.$router.push({ name: 'staff', params: { id: this.$route.params.id} });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Служители',
            to: { name: 'staff', params: { id: this.$route.params.id} },
        }, {
            text: 'Създаване',
        }];
        // Initializing the user data object
        this.userData = {
            first_name: '', last_name: '', email: '',
            phone: '', password: '', password_confirmation: '',
            roles: [], permissions: [],
        };
    },
};
